"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const ModalContent = createJourneyComponent_1.createJourneyComponent('j-modal-content', 'div');
exports.default = withJourney_1.default('j-modal-content', ModalContent);
